import { render, staticRenderFns } from "./EmcPublicity.vue?vue&type=template&id=5880d5e0&scoped=true&lang=html&"
import script from "./EmcPublicity.vue?vue&type=script&lang=js&"
export * from "./EmcPublicity.vue?vue&type=script&lang=js&"
import style0 from "./EmcPublicity.vue?vue&type=style&index=0&id=5880d5e0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880d5e0",
  null
  
)

export default component.exports